import { useForm } from "react-hook-form";
import { useState } from "react";
import { useLocation, useNavigate } from "react-router";
import { useDispatch } from "react-redux";
import { setCredentials } from "../api/auth/authSlice";
import { useLoginMutation } from "../api/auth/authApi";
import { Credentials } from "../types/auth";
import { CircularProgress } from "@mui/joy";


export function Login() {
    const [isError, setIsError] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");

    const navigate = useNavigate();
    const location = useLocation();
    const from = location.state?.from?.pathname || "/";

    const [login, { isLoading, error }] = useLoginMutation();
    const dispatch = useDispatch();

    const {
        register,
        handleSubmit,
        reset,
        formState: {
            errors,
        },
    } = useForm<Credentials>();


    const submitLogin = handleSubmit(async (data: Credentials) => {

        try {
            setIsError(false);

            const userData = await login({ username: data.username, password: data.password }).unwrap();

            dispatch(setCredentials(userData))

            reset();
            navigate(from, { replace: true });

        } catch (err: any) {
            if(err.status === 400) {
                setIsError(true);
                setErrorMessage("Credenciales incorrectas.");
            }
        }

    });

    return (
        <div className="bg-gray-900 w-full h-screen flex items-center flex-col py-20">
            <img 
                className="w-96"
                src="/logo_regiodental.png" 
                alt="Logo Regiodental"/>
            

            <form onSubmit={submitLogin} className="grid w-96 gap-y-4" autoComplete="off">

                <p className="text-gray-400 text-center font-semibold text-xl">Inicio de Sesión</p>

                <div className="flex gap-2">
                    <input 
                        {...register("username", {
                            required: "El usuario es requerido.",
                        })}
                        className="
                            border-2 border-gray-500 bg-gray-50 focus:outline-none rounded w-full
                            px-2 font-normal text-gray-600 h-[40px]"
                        placeholder="Usuario"
                        type="text"/>
                </div>

                {errors.username?.type === "required" && (
                    <p className="valErrorText">{errors.username.message}</p>
                )}

                <div>
                    <input 
                        {...register("password", {
                            required: "La contraseña es requerida."
                        })}
                        className="
                            border-2 border-gray-500 bg-gray-50 focus:outline-none rounded w-full
                            px-2 font-normal text-gray-600 h-[40px]"
                        placeholder="Contraseña"
                        type="password"/>
                </div>

                {errors.password?.type === "required" && (
                    <p className="valErrorText">{errors.password.message}</p>
                )}

                {isLoading
                ? 
                <div className="flex justify-center">
                    <CircularProgress />
                </div>
                :
                <input
                    className="font-semibold bg-gray-300 rounded my-2 py-2 text-gray-600 h-[40px]"
                    type="submit"
                    value="Iniciar Sesión"/>
                }

                {isError && (
                    <p className="valErrorText text-center text-xl">{errorMessage}</p>
                )}

            </form>
            
        </div>
    );
}